export const apiDomains = "https://ironlinc-dev.azurewebsites.net";

// export const apiDomains = isDebug
//   ? "https://ironlinc-dev.azurewebsites.net"
//   : "https://auth.flatironrealtycapital.com";

// export const apiDomains = isDebug
//   ? "http://20.228.154.238:8001"
//   : "https://auth.flatironrealtycapital.com";
